import React, { forwardRef } from 'react';
import { motion } from 'framer-motion';

const PageComponent = forwardRef(function PageComponent({ children }, ref) {
  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -20 }}
      transition={{
        duration: 0.3,
        type: "tween",
        ease: "easeInOut"
      }}
      style={{ 
        width: '100%',
        height: '100%'
      }}
    >
      {children}
    </motion.div>
  );
});

export default PageComponent;
